import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid';
import {ReactNode} from 'react';
import {Button} from '../forms';

interface AlertBannerProps {
  alertMessage: string | ReactNode;
  alertTitle: string | ReactNode;
  alertType: 'warning' | 'error' | 'info' | 'success';
  rightButtonLabel?: string | ReactNode;
  rightButtonAction?: () => void;
}
export const AlertBanner = ({
  alertMessage,
  alertTitle,
  alertType,
  rightButtonLabel,
  rightButtonAction,
}: AlertBannerProps) => {
  const alertStyles = {
    warning: {
      bgColor: 'bg-yellow-50',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-400',
      icon: ExclamationTriangleIcon,
    },
    error: {
      bgColor: 'bg-red-50',
      textColor: 'text-red-800',
      iconColor: 'text-red-400',
      icon: XCircleIcon,
    },
    info: {
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-800',
      iconColor: 'text-blue-400',
      icon: InformationCircleIcon,
    },
    success: {
      bgColor: 'bg-green-50',
      textColor: 'text-green-800',
      iconColor: 'text-green-400',
      icon: CheckCircleIcon,
    },
  };

  const {bgColor, textColor, iconColor, icon: Icon} = alertStyles[alertType];

  return (
    <div className={`rounded-md ${bgColor} p-4`}>
      <div className="flex">
        <div className="shrink-0">
          <Icon className={`size-5 ${iconColor}`} aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${textColor}`}>{alertTitle}</h3>
          <div className={`mt-2 text-sm ${textColor.replace('800', '700')}`}>
            <p>{alertMessage}</p>
          </div>
        </div>
        <div className="pl-3 ml-auto">
          {rightButtonLabel && rightButtonAction && (
            <Button
              type="button"
              variant="primary"
              size="md"
              className="w-fit max-sm:w-full"
              onClick={rightButtonAction}
            >
              {rightButtonLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
